// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__3UA0c","inner":"Form_inner__1ggCD","range":"Form_range__1YZ1y","name":"Form_name__2_d-e","actions":"Form_actions__1GjCW"};